/* ==========================================================================
   ARTEZCOM · Nuevo Home — interacciones (sin dependencias)
   ========================================================================== */
(() => {
  if (window.__azHome) return;
  window.__azHome = true;

  const money = (cents) => '$' + Math.round((cents || 0) / 100).toLocaleString('es-CO');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = (el) => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const isDesign = () => document.documentElement.classList.contains('shopify-design-mode');

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -6% 0px', threshold: 0.06 })
    : null;
  const reveal = (root) => $$('[data-az-reveal]:not(.is-in)', root).forEach((el) => (io && !isDesign() ? io.observe(el) : el.classList.add('is-in')));

  /* ---------- Rails ---------- */
  const updateRail = (rail) => {
    const tr = $('[data-az-rail-track]', rail);
    if (!tr) return;
    const max = tr.scrollWidth - tr.clientWidth - 2;
    const prev = $('[data-az-prev]', rail);
    const next = $('[data-az-next]', rail);
    if (prev) prev.disabled = tr.scrollLeft <= 2;
    if (next) next.disabled = tr.scrollLeft >= max;
    const nav = $('.az-rail__nav', rail);
    if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
  };
  const initRails = (root) => $$('[data-az-rail]', root).forEach((rail) => {
    if (rail._az) return; rail._az = true;
    const tr = $('[data-az-rail-track]', rail);
    const step = () => { const it = $('.az-rail__item', tr); return it ? it.getBoundingClientRect().width + 16 : tr.clientWidth * 0.8; };
    $('[data-az-prev]', rail)?.addEventListener('click', () => tr.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-az-next]', rail)?.addEventListener('click', () => tr.scrollBy({ left: step(), behavior: 'smooth' }));
    tr.addEventListener('scroll', () => updateRail(rail), { passive: true });
    window.addEventListener('resize', () => updateRail(rail), { passive: true });
    updateRail(rail);
  });

  /* ---------- Tabs (accessible) ---------- */
  const initTabs = (root) => $$('[data-az-tabs]', root).forEach((wrap) => {
    if (wrap._az) return; wrap._az = true;
    const tabs = $$('[role="tab"]', wrap).filter((b) => b.closest('[data-az-tabs]') === wrap);
    const select = (btn, focus) => {
      tabs.forEach((b) => {
        const on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) btn.focus();
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) { reveal(panel); $$('[data-az-rail]', panel).forEach(updateRail); }
      wrap.dispatchEvent(new CustomEvent('az:tab', { bubbles: true }));
      const bar = btn.parentElement;
      if (bar && bar.scrollWidth > bar.clientWidth) {
        const left = btn.offsetLeft - (bar.clientWidth - btn.clientWidth) / 2;
        bar.scrollTo({ left, behavior: 'smooth' });
      }
    };
    tabs.forEach((b, i) => {
      b.addEventListener('click', () => select(b));
      b.addEventListener('keydown', (e) => {
        const map = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 };
        if (e.key in map) { e.preventDefault(); select(tabs[map[e.key]], true); }
      });
    });
  });

  /* ---------- Variant picker (cards, match base) ---------- */
  class Picker {
    constructor(el, onChange) {
      this.el = el;
      this.data = parse($('[data-az-json]', el)) || { variants: [] };
      this.groups = $$('[data-az-opt]', el);
      this.sel = {};
      this.groups.forEach((g) => { const a = $('.is-active', g); if (a) this.sel[g.dataset.azOpt] = a.dataset.value; });
      this.onChange = onChange;
      this.groups.forEach((g) => g.addEventListener('click', (e) => {
        const b = e.target.closest('[data-value]');
        if (!b) return;
        this.choose(g.dataset.azOpt, b.dataset.value);
      }));
      this.variant = this.find();
      this.markAvailability();
    }
    matches(v, sel) { return Object.entries(sel).every(([i, val]) => v.o[i] === val); }
    find(sel = this.sel) {
      const m = this.data.variants.filter((v) => this.matches(v, sel));
      return m.find((v) => v.a) || m[0] || null;
    }
    choose(index, value) {
      this.sel[index] = value;
      let v = this.find();
      if (!v || !v.a) {
        const alt = this.data.variants.find((x) => x.a && x.o[index] === value);
        if (alt) Object.keys(this.sel).forEach((k) => { this.sel[k] = alt.o[k]; });
        v = this.find();
      }
      this.variant = v;
      this.paint();
      if (this.onChange) this.onChange(v, this);
    }
    paint() {
      this.groups.forEach((g) => {
        const i = g.dataset.azOpt;
        $$('[data-value]', g).forEach((b) => {
          const on = b.dataset.value === this.sel[i];
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
      this.markAvailability();
    }
    markAvailability() {
      this.groups.forEach((g) => {
        const i = g.dataset.azOpt;
        $$('.az-chip[data-value]', g).forEach((b) => {
          const test = { ...this.sel, [i]: b.dataset.value };
          const ok = this.data.variants.some((v) => v.a && this.matches(v, test));
          b.classList.toggle('is-unavailable', !ok);
        });
      });
    }
  }

  const swapImage = (img, url) => {
    if (!img || !url) return;
    const src = url.replace(/([?&])width=\d+/, '$1width=900');
    if (img.getAttribute('src') === src) return;
    img.style.opacity = '0';
    const pre = new Image();
    pre.onload = () => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; img.style.opacity = ''; };
    pre.onerror = () => { img.style.opacity = ''; };
    pre.src = src;
  };

  /* ---------- Product cards ---------- */
  const initCards = (root) => $$('[data-az-card]', root).forEach((card) => {
    if (card._az || !$('[data-az-json]', card)) return; card._az = true;
    const input = $('[data-az-variant-input]', card);
    const addBtn = $('[data-az-add]', card);
    const label = $('[data-az-add-label]', card);
    const priceEl = $('[data-az-price]', card);
    const save = $('[data-az-save]', card);
    const img = $('.az-card__img--main', card);
    const render = (v) => {
      if (!v) return;
      if (input) input.value = v.id;
      if (addBtn) addBtn.disabled = !v.a;
      if (label) label.textContent = v.a ? 'Añadir al carrito' : 'Agotado';
      if (priceEl) priceEl.innerHTML = `<span class="az-card__now">${money(v.p)}</span>${v.c > v.p ? `<s class="az-card__was">${money(v.c)}</s>` : ''}`;
      if (save) {
        const pct = v.c > v.p ? Math.floor(((v.c - v.p) * 100) / v.c) : 0;
        save.hidden = pct < 1;
        const n = $('[data-az-save-pct]', save); if (n) n.textContent = pct;
      }
      if (v.img) swapImage(img, v.img);
    };
    card._picker = new Picker(card, render);
    card._render = render;
    $('[data-az-qv]', card)?.addEventListener('click', () => openQuickView(card));
  });

  /* ---------- Quick view ---------- */
  let qv;
  const ICON = (d) => `<svg class="az-icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;
  const buildQV = () => {
    qv = document.createElement('dialog');
    qv.className = 'az-qv';
    qv.setAttribute('aria-label', 'Vista rápida');
    qv.innerHTML = `
      <button type="button" class="az-round az-qv__close" data-az-qv-close aria-label="Cerrar">${ICON('<path d="M14 14l20 20M34 14L14 34"/>')}</button>
      <div class="az-qv__grid">
        <div class="az-qv__gallery"><div class="az-qv__main"><img alt="" data-az-qv-img></div><div class="az-qv__thumbs" data-az-qv-thumbs></div></div>
        <div class="az-qv__info">
          <h2 class="az-qv__title" data-az-qv-title></h2>
          <div class="az-qv__price" data-az-qv-price></div>
          <p class="az-qv__fin">o paga hasta en 24 cuotas con Addi</p>
          <div class="az-qv__opts" data-az-qv-opts></div>
          <button type="button" class="az-btn az-btn--solid" data-az-qv-add>Añadir al carrito</button>
          <a class="az-link az-link--sm" data-az-qv-link href="#">Ver detalles completos ${ICON('<path d="M10 24h28M27 13l11 11-11 11"/>')}</a>
          <p class="az-qv__desc" data-az-qv-desc></p>
          <ul class="az-qv__trust">
            <li>${ICON('<path d="M24 5.5l14 5v11c0 9.2-6 16.6-14 21-8-4.4-14-11.8-14-21v-11z"/><path d="M17.5 24l4.5 4.5 8.5-9"/>')}Original, sellado y con garantía de 12 meses</li>
            <li>${ICON('<path d="M4.5 12.5h24v20h-24z"/><path d="M28.5 18.5h7.5l6.5 7.5v6.5h-14z"/><circle cx="13" cy="35" r="3.5"/><circle cx="35" cy="35" r="3.5"/>')}Envío a todo el país en 1–3 días hábiles</li>
          </ul>
        </div>
      </div>`;
    document.body.appendChild(qv);
    qv.addEventListener('click', (e) => { if (e.target === qv || e.target.closest('[data-az-qv-close]')) qv.close(); });
    return qv;
  };

  function openQuickView(card) {
    const d = card._picker.data;
    if (!qv) buildQV();
    const sel = { ...card._picker.sel };
    const imgEl = $('[data-az-qv-img]', qv);
    const thumbs = $('[data-az-qv-thumbs]', qv);
    const opts = $('[data-az-qv-opts]', qv);
    const priceEl = $('[data-az-qv-price]', qv);
    const add = $('[data-az-qv-add]', qv);
    $('[data-az-qv-title]', qv).textContent = d.title;
    $('[data-az-qv-desc]', qv).textContent = d.desc || '';
    $('[data-az-qv-link]', qv).href = d.url;
    imgEl.removeAttribute('src');

    const setImg = (u) => { if (u) { imgEl.src = u; imgEl.alt = d.title; } $$('button', thumbs).forEach((b) => b.classList.toggle('is-active', b.dataset.src === u)); };
    thumbs.innerHTML = '';
    (d.media || []).forEach((u) => {
      const b = document.createElement('button');
      b.type = 'button'; b.dataset.src = u; b.setAttribute('aria-label', 'Ver imagen');
      b.innerHTML = `<img src="${u.replace(/width=\d+/, 'width=160')}" alt="" loading="lazy">`;
      b.addEventListener('click', () => setImg(u));
      thumbs.appendChild(b);
    });

    const hexFor = (value) => { const s = $$('.az-swatch', card).find((x) => x.dataset.value === value); return s ? s.style.getPropertyValue('--sw') : null; };
    const find = () => { const m = d.variants.filter((v) => Object.entries(sel).every(([k, val]) => v.o[k] === val)); return m.find((v) => v.a) || m[0] || null; };
    opts.innerHTML = '';
    (d.options || []).forEach((name, i) => {
      const values = [...new Set(d.variants.map((v) => v.o[i]))];
      if (values.length < 2) return;
      if (sel[i] === undefined) sel[i] = (d.variants.find((v) => v.a) || d.variants[0]).o[i];
      const isColor = /^colou?r/i.test(name);
      const wrap = document.createElement('div');
      wrap.dataset.i = i;
      wrap.innerHTML = `<span class="az-qv__opt-label">${name} · <span data-l></span></span><div class="${isColor ? 'az-swatches' : 'az-chips'}" role="radiogroup" aria-label="${name}"></div>`;
      const g = wrap.lastElementChild;
      values.forEach((val) => {
        const b = document.createElement('button');
        b.type = 'button'; b.dataset.value = val; b.setAttribute('role', 'radio');
        if (isColor) { b.className = 'az-swatch az-swatch--lg'; b.style.setProperty('--sw', hexFor(val) || '#d4d4d8'); b.setAttribute('aria-label', val); b.title = val; }
        else { b.className = 'az-chip'; b.textContent = val.replace(/ Gb$/, ' GB').replace(/ Tb$/, ' TB'); }
        b.addEventListener('click', () => {
          sel[i] = val;
          const v = find();
          if (!v || !v.a) { const alt = d.variants.find((x) => x.a && x.o[i] === val); if (alt) Object.keys(sel).forEach((k) => { sel[k] = alt.o[k]; }); }
          paint(true);
        });
        g.appendChild(b);
      });
      opts.appendChild(wrap);
    });

    function paint(changeImg) {
      $$('[data-i]', opts).forEach((w) => {
        const i = w.dataset.i; $('[data-l]', w).textContent = sel[i];
        $$('[data-value]', w).forEach((b) => {
          const on = b.dataset.value === sel[i];
          b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
          if (b.classList.contains('az-chip')) {
            const t = { ...sel, [i]: b.dataset.value };
            b.classList.toggle('is-unavailable', !d.variants.some((v) => v.a && Object.entries(t).every(([k, val]) => v.o[k] === val)));
          }
        });
      });
      const v = find();
      if (!v) return;
      priceEl.innerHTML = `${money(v.p)}${v.c > v.p ? `<s>${money(v.c)}</s>` : ''}`;
      add.disabled = !v.a; add.textContent = v.a ? 'Añadir al carrito' : 'Agotado';
      add.style.opacity = v.a ? '' : '.5';
      if (changeImg || !imgEl.getAttribute('src')) setImg(v.img ? v.img.replace(/width=\d+/, 'width=1100') : (d.media || [])[0]);
    }
    paint(true);

    add.onclick = () => {
      const v = find(); if (!v || !v.a) return;
      Object.entries(sel).forEach(([k, val]) => { if (card._picker.groups.some((g) => g.dataset.azOpt === k)) card._picker.sel[k] = val; });
      card._picker.variant = v; card._picker.paint(); card._render(v);
      const form = document.getElementById(d.form);
      const input = $('[data-az-variant-input]', card);
      if (input) input.value = v.id;
      qv.close();
      const btn = form && $('[type="submit"]', form);
      if (btn) { btn.disabled = false; if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); }
    };
    qv.showModal();
  }

  /* ---------- Hero color switch ---------- */
  const initHero = (root) => $$('[data-az-hero]', root).forEach((hero) => {
    if (hero._az) return; hero._az = true;
    const imgs = $$('.az-hero__img', hero);
    const label = $('[data-az-hero-color]', hero);
    $$('[data-az-hero-swatch]', hero).forEach((b) => b.addEventListener('click', () => {
      const i = +b.dataset.azHeroSwatch;
      $$('[data-az-hero-swatch]', hero).forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (imgs.length > 1) imgs.forEach((im, k) => { if (k === i && im.loading === 'lazy') im.loading = 'eager'; im.classList.toggle('is-active', k === i); });
      if (label) label.textContent = b.dataset.value;
    }));
  });

  /* ---------- Plan Retoma -> WhatsApp ---------- */
  const initQuote = (root) => $$('[data-az-quote]', root).forEach((f) => {
    if (f._az) return; f._az = true;
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(f);
      const msg = `${f.dataset.msg}\n• Equipo actual: ${fd.get('modelo')}\n• Estado: ${fd.get('estado')}`;
      window.open(`https://wa.me/${f.dataset.wa}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
    });
  });

  /* ---------- Cart drawer refresh (multi-item adds) ---------- */
  const drawerSectionId = () => $('cart-drawer[data-section-id]')?.dataset.sectionId;
  const refreshCart = async (sections) => {
    const id = drawerSectionId();
    const drawer = $('cart-drawer');
    let html = sections && id ? sections[id] : null;
    if (!html && id) { try { html = await (await fetch(`${window.location.pathname}?section_id=${id}`)).text(); } catch (e) { html = null; } }
    if (html && drawer) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const panelId = `MiniCart-${id}`;
      const fresh = doc.getElementById(panelId);
      const current = document.getElementById(panelId);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    try {
      const cart = await (await fetch('/cart.js')).json();
      $$('cart-count').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    } catch (e) { /* noop */ }
    if (drawer) {
      if (typeof drawer.show === 'function') drawer.show();
      else if (typeof drawer.open === 'function') drawer.open();
      else { const t = $$('[aria-controls="CartDrawer"]').find((x) => !drawer.contains(x)); if (t) t.click(); }
    } else {
      window.location.href = '/cart';
    }
  };

  /* ---------- El Match Perfecto ---------- */
  const alertInline = (root, msg) => {
    let n = $('.az-match__error', root);
    if (!n) { n = document.createElement('p'); n.className = 'az-match__error az-match__note'; n.setAttribute('role', 'alert'); n.style.color = '#ffb3b8'; $('.az-match__summary', root)?.appendChild(n); }
    n.textContent = msg;
  };

  const initMatch = (root) => $$('[data-az-match]', root).forEach((m) => {
    if (m._az) return; m._az = true;
    const thumbs = $('[data-az-match-thumbs]', m);
    const out = (k) => $(`[data-az-match-${k}]`, m);
    const accRows = $$('[data-az-acc]', m);
    let bases = [];
    const activeBase = () => bases.find((b) => !b.el.hidden) || bases[0];
    const accVariant = (row) => {
      const s = $('[data-az-acc-variant]', row);
      if (!s) return null;
      if (s.tagName === 'SELECT') { const o = s.selectedOptions[0]; return { id: +s.value, p: +o.dataset.p, c: +o.dataset.c }; }
      return { id: +s.value, p: +s.dataset.p, c: +s.dataset.c };
    };
    const items = () => {
      const list = [];
      const b = activeBase();
      if (b && b.p.variant && b.p.variant.a) list.push({ id: b.p.variant.id, p: b.p.variant.p, c: b.p.variant.c, img: b.img ? (b.img.currentSrc || b.img.src) : null });
      accRows.forEach((row) => {
        if (!$('[data-az-acc-check]', row)?.checked) return;
        const v = accVariant(row); if (!v) return;
        const im = $('.az-acc__img img', row);
        list.push({ ...v, img: im ? (im.currentSrc || im.src) : null });
      });
      return list;
    };
    const compute = () => {
      const list = items();
      const total = list.reduce((s, x) => s + x.p, 0);
      const was = list.reduce((s, x) => s + Math.max(x.c || 0, x.p), 0);
      const saved = was - total;
      out('count').textContent = list.length;
      out('total').textContent = money(total);
      out('list').textContent = money(was);
      out('save').textContent = money(saved);
      out('list-row').hidden = saved <= 0;
      out('save-row').hidden = saved <= 0;
      thumbs.innerHTML = list.map((x) => `<span>${x.img ? `<img src="${x.img}" alt="" loading="lazy">` : ''}</span>`).join('');
      $('[data-az-match-add]', m).disabled = list.length === 0;
    };
    bases = $$('[data-az-match-base]', m).map((el) => {
      const img = $('.az-match__img img', el);
      const price = $('[data-az-price]', el);
      const p = new Picker(el, (v) => {
        if (!v) return;
        price.innerHTML = `${money(v.p)}${v.c > v.p ? `<s>${money(v.c)}</s>` : ''}${v.a ? '' : ' · Agotado'}`;
        if (v.img) swapImage(img, v.img);
        setTimeout(compute, 450);
        compute();
      });
      return { el, p, img };
    });
    accRows.forEach((row) => {
      $('[data-az-acc-check]', row)?.addEventListener('change', compute);
      $('select[data-az-acc-variant]', row)?.addEventListener('change', (e) => {
        const o = e.target.selectedOptions[0];
        const pe = $('[data-az-acc-price]', row); if (pe) pe.textContent = money(+o.dataset.p);
        compute();
      });
    });
    m.addEventListener('az:tab', compute);

    $('[data-az-match-add]', m).addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const list = items();
      if (!list.length) return;
      btn.setAttribute('aria-busy', 'true');
      const original = btn.textContent;
      btn.textContent = 'Agregando…';
      try {
        const id = drawerSectionId();
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: list.map((x) => ({ id: x.id, quantity: 1 })), sections: id ? [id] : undefined, sections_url: window.location.pathname })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'No se pudo agregar');
        if (m.dataset.code) { try { await fetch(`/discount/${encodeURIComponent(m.dataset.code)}`, { credentials: 'same-origin' }); } catch (_) { /* noop */ } }
        await refreshCart(json.sections);
        btn.textContent = '¡Listo! Tu Match está en el carrito';
        setTimeout(() => { btn.textContent = original; }, 2600);
      } catch (err) {
        btn.textContent = original;
        alertInline(m, err.message);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
    compute();
    window.addEventListener('load', compute);
  });

  /* ---------- Footer accordions closed on mobile ---------- */
  const initFooter = (root) => {
    if (window.matchMedia('(max-width: 989px)').matches) $$('.az-footer__col[open]', root).forEach((d) => d.removeAttribute('open'));
  };

  /* ---------- Boot ---------- */
  const boot = (root = document) => {
    initTabs(root); initRails(root); initCards(root); initHero(root); initQuote(root); initMatch(root); initFooter(root); reveal(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
